import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { appCRUD } from "../../../actions/app";
import { char } from "../../../utils";

export const DataDay = () => {

    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(null);
    const [labels, setLabels] = useState([]);
    const [series, setSeries] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            appCRUD.loadDashboardDataDays().then((resp) => {
                setLabels(resp.data.labels);
                setSeries(resp.data.results);
            })
            .catch(() => {})
            .finally(() => {
                setLoading(false)
            })
        },500)
    },[])


    const state = {
      series: [
        {
          name: "Collections",
          data: series ? series.collection : [],
        },
        {
          name: "Revenue",
          data: series ? series.revenue : [],
        },
        {
          name: "Expensis",
          data: series ? series.expensis : [],
        },
      ],
      options: {
        chart: {
          height: 350,
          type: "bar",
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const dataPointIndex = config.dataPointIndex;
              const label = state.options.xaxis.categories[dataPointIndex];
              setStatus(char.toLowerCase(label));
              setOpen(true);
            },
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val;
          },
          offsetY: -15,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },
        stroke: {
          show: true,
          width: 0.1,
          colors: ["transparent"],
        },

        xaxis: {
          categories: labels,
          position: "bottom",
          axisBorder: {
            show: true,
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              },
            },
          },
        },
        yaxis: {
          title: {
            text: "thousands",
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return val;
            },
          },
        },
        title: {
          text: "Collection Summary From Last Year",
          floating: true,
          offsetY: 0,
          align: "center",
          style: {
            color: "#444",
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return  val ;
            },
          },
        },
      },
    };
        

    return (
      <>
        {loading ? (
          <div className="text-center mt-4 mb-4">
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 24,
                  }}
                  spin
                />
              }
            />
          </div>
        ) : (
          <Chart
            options={state.options}
            series={state.series}
            type="bar"
            height={350}
          />
        )}
      </>
    );

}